// extracted by mini-css-extract-plugin
module.exports = {"InputOptionSelect":"styles_InputOptionSelect__2jNXH","InputOptionSelectLabel":"styles_InputOptionSelectLabel__2AUpk"};